import React from "react";

import PropTypes from "prop-types";
import SignaturePad from "signature_pad";
import AnalyticsTracking from "Utils/AnalyticsTracking";

export default class SignPad extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.handleStrokeEnd = this.handleStrokeEnd.bind(this);
  }

  isEmpty() {
    return !this.state.value && (!this.signaturePad || this.signaturePad.isEmpty());
  }

  clear() {
    if (this.state.value && this.props.onChange) {
      this.props.onChange(null);
    }

    this.setState({
      value: null,
    });

    if (this.signaturePad) {
      AnalyticsTracking.trackEvent("signature_cleared", {
        location: "sign_pad",
      });
      this.signaturePad.clear();
    }
  }

  componentDidMount() {
    this.signaturePad = new SignaturePad(this.canvas, {
      onBegin: (e) => this.props.onBegin(e),
      onEnd: this.handleStrokeEnd,
    });

    if (this.state.value) {
      this.signaturePad.fromDataURL(this.state.value);
    }
  }

  componentDidUpdate(prevProps: Readonly<any>) {
    const incoming = this.props.value;

    // Only react if the prop value actually changed
    if (incoming !== prevProps.value) {
      // If cleared from outside, clear the pad
      if (!incoming) {
        this.signaturePad?.clear();
        if (this.state.value !== incoming) {
          this.setState({ value: incoming });
        }
        return;
      }

      // If we have an external value & the canvas is empty, draw it once.
      if (this.signaturePad && this.signaturePad.isEmpty()) {
        this.signaturePad.fromDataURL(incoming);
      }

      if (this.state.value !== incoming) {
        this.setState({ value: incoming });
      }
    }
  }

  handleStrokeEnd(e) {
    AnalyticsTracking.trackEvent("signature_ended", {
      location: "sign_pad",
    });

    if (!this.signaturePad.isEmpty()) {
      const value = this.signaturePad.toDataURL();
      this.setState({
        value,
      });

      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }

    if (this.props.onEnd) {
      this.props.onEnd.call(null, e);
    }
  }

  render() {
    /* eslint-disable no-unused-vars */
    const { width, height, name, onBegin, onEnd, value, ...rest } = this.props;

    /* eslint-enable no-unused-vars */
    return (
      <div {...rest}>
        <canvas
          ref={(canvas) => (this.canvas = canvas)}
          // Do NOT set width/height attributes here; let signature_pad resize using CSS box + DPR
          style={{ width: `${width}px`, height: `${height}px` }}
        />
        <input ref={(input) => (this.input = input)} type="hidden" name={name} value={this.state.value || ""} />
      </div>
    );
  }
}
SignPad.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  value: PropTypes.string,
  onBegin: PropTypes.func,
  onEnd: PropTypes.func,
  name: PropTypes.string.isRequired,
};
SignPad.defaultProps = {
  width: 300,
  height: 100,
};
